var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['navigation-element',{active:_vm.active}]},[_c('cms-icon',{attrs:{"iconName":_vm.title,"width":"29","height":"29"}},[_vm._t("default")],2),_c('span',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }